import orderAggregatorService from './orderAggregatorService.service'

export default orderAggregatorService
